import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useParseDocumentToHtml } from '~/composables/useParseDocumentToHtml';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import { useGetComponentName } from '~/composables/useGetComponentName';
import { useCheckIfValueExistsInDisplayOptions } from '~/composables/useCheckIfValueExistsInDisplayOptions';
import BlockImagesTextStandard from '~/components/cms/custom/BlockImagesText/BlockImagesTextStandard.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BlockImagesText',
  props: {
    title: null,
    text: null,
    displayOptions: {
      default: function _default() {
        return [];
      }
    },
    pictos: null,
    backgroundWhite: {
      type: Boolean
    },
    isOverlay: {
      type: Boolean
    },
    bottomContent: {
      type: Boolean
    },
    isRecipePage: {
      type: Boolean
    },
    isHomePage: {
      type: Boolean
    },
    isPageAdvice: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var BlockImagesTextImageLeftTextRight = function BlockImagesTextImageLeftTextRight() {
      return import('~/components/cms/custom/BlockImagesText/BlockImagesTextImageLeftTextRight.vue');
    };
    var BlockImagesTextImageRightTextLeft = function BlockImagesTextImageRightTextLeft() {
      return import('~/components/cms/custom/BlockImagesText/BlockImagesTextImageRightTextLeft.vue');
    };
    var BlockImagesTextImageBottomTextTop = function BlockImagesTextImageBottomTextTop() {
      return import('~/components/cms/custom/BlockImagesText/BlockImagesTextImageBottomTextTop.vue');
    };
    var BlockImagesTextSmall = function BlockImagesTextSmall() {
      return import('~/components/cms/custom/BlockImagesText/BlockImagesTextSmall.vue');
    };
    var BlockImagesTextStandardTab = function BlockImagesTextStandardTab() {
      return import('~/components/cms/custom/BlockImagesText/BlockImagesTextStandardTab.vue');
    };
    var classes = computed(function () {
      var _props$text, _props$text$content;
      var nodeTypes = (_props$text = props.text) === null || _props$text === void 0 ? void 0 : (_props$text$content = _props$text.content) === null || _props$text$content === void 0 ? void 0 : _props$text$content.reduce(function (types, node) {
        types.add("node-".concat(node.nodeType));
        return types;
      }, new Set());
      return nodeTypes !== null && nodeTypes !== void 0 && nodeTypes.size ? _objectSpread(_objectSpread({}, useGetDisplayOptionsClasses(props.displayOptions)), {}, {
        nodeTypes: _toConsumableArray(nodeTypes).join(' ')
      }) : useGetDisplayOptionsClasses(props.displayOptions);
    });
    var text = computed(function () {
      return props.text;
    });
    var _useParseDocumentToHt = useParseDocumentToHtml(text, props.displayOptions),
      parsedDescription = _useParseDocumentToHt.html;
    var fieldName = inject('fieldName', '');
    var componentName = useGetComponentName({
      'standard': fieldName === 'tab' ? BlockImagesTextStandardTab : BlockImagesTextStandard,
      'image-left-text-right': BlockImagesTextImageLeftTextRight,
      'image-right-text-left': BlockImagesTextImageRightTextLeft,
      'image-bottom-text-top': BlockImagesTextImageBottomTextTop,
      'image-text-small': BlockImagesTextSmall
    }, props.displayOptions);
    var hasLeafBulletListOption = computed(function () {
      return useCheckIfValueExistsInDisplayOptions('leaf-bullet-list', props.displayOptions);
    });
    return {
      __sfc: true,
      BlockImagesTextImageLeftTextRight: BlockImagesTextImageLeftTextRight,
      BlockImagesTextImageRightTextLeft: BlockImagesTextImageRightTextLeft,
      BlockImagesTextImageBottomTextTop: BlockImagesTextImageBottomTextTop,
      BlockImagesTextSmall: BlockImagesTextSmall,
      BlockImagesTextStandardTab: BlockImagesTextStandardTab,
      props: props,
      classes: classes,
      text: text,
      parsedDescription: parsedDescription,
      fieldName: fieldName,
      componentName: componentName,
      hasLeafBulletListOption: hasLeafBulletListOption
    };
  }
});